import React from "react";
import {useTranslation} from "react-i18next";
import {Stack} from "@mui/material";
import {SubmissionDto} from "../../client/submission/SubmissionApiClient";
import {SubmissionTranslKey} from "./SubmissionTranslKey";
import {SubmissionStateTypeFormatter} from "./SubmissionStateTypeFormatter";
import {formatUserLastNameFirst} from "../user/UserFormatter";
import {DateTimeFormatter} from "../../common/DateTimeFormatter";
import {DetailsTable} from "../../common/details/DetailsTable";
import {DetailsTextRow} from "../../common/details/DetailsTextRow";
import {CatalogType} from "../../client/catalog/CatalogType";

export interface SubmissionDetailPanelProps {
    submission: SubmissionDto;
}

export default function SubmissionBasicDetailPanel(props: Readonly<SubmissionDetailPanelProps>) {
    const {submission} = props;

    const {t} = useTranslation();
    const submittedAt = DateTimeFormatter.formatDateTime(submission.submittedAt);

    return (
        <Stack spacing={2} padding={1}>
            <DetailsTable>
                <DetailsTextRow label={t(SubmissionTranslKey.DOCUMENT_NUMBER)}
                                value={submission.submissionNumber}/>
                <DetailsTextRow label={t(SubmissionTranslKey.DOCUMENT_TYPE)}
                                value={t(submission.documentMetadata.type?.code ?? '', {ns: CatalogType.DOCUMENT_TYPE})}/>
                <DetailsTextRow label={t(SubmissionTranslKey.CURRENT_STATE)}
                                value={SubmissionStateTypeFormatter.formatSubmissionStateType(submission?.currentSubmissionState?.type, t)}/>
                <DetailsTextRow label={t(SubmissionTranslKey.SUBMITTED_BY)}
                                value={formatUserLastNameFirst(submission.submittedBy)}/>
                <DetailsTextRow label={t(SubmissionTranslKey.SUBMITTED_AT)}
                                value={submittedAt ?? undefined}/>
            </DetailsTable>
        </Stack>
    );
}
